import { render } from "./CreateOrEditClient.vue?vue&type=template&id=b702ea0e&scoped=true"
import script from "./CreateOrEditClient.vue?vue&type=script&lang=js"
export * from "./CreateOrEditClient.vue?vue&type=script&lang=js"

import "./CreateOrEditClient.vue?vue&type=style&index=0&id=b702ea0e&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b702ea0e"]])

export default __exports__